// Import local utilities
import ready from './utilities/ready';

// Modules
import mainMenu from './modules/mainMenu';
import scrollEvents from './modules/scrollEvents';
import hero from './modules/hero';
import logoShow from './modules/logoShow';
import testimonialSlider from './modules/testimonialSlider';
import accordion from './modules/accordion';
import cardCarousel from './modules/cardCarousel';
import imageTextCarousel from './modules/imageTextCarousel';
import setBackgroundFeaturedLinks from './modules/featuredLinks';
import tabs from './modules/tabs';
import imageCarousel from './modules/imageCarousel';
import heroCarousel from './modules/heroCarousel';
import announcements from './modules/announcements';
import awards from './modules/awards';

// Init Function
const init = () => {
	accordion();
	cardCarousel();
	hero();
	heroCarousel();
	imageCarousel();
	imageTextCarousel();
	logoShow();
	mainMenu();
	scrollEvents();
	tabs();
	testimonialSlider();
	setBackgroundFeaturedLinks();
	announcements();
	awards();
};

ready(init);
